import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { soldeActions } from "../../sagas/soldeSlice";
import { Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input, Table, Spinner } from "reactstrap";
import { FaTruck, FaFileExport, FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { format } from "date-fns";
import { supplierActions } from "../../sagas/supplierSlice";

const formatMoney = (n) =>
        (Number(n || 0))
            .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const MouvementSoldeFournisseur = () => {
    const { soldesFournisseur, loading, error } = useSelector((state) => state.soldes);
    const fournisseurs = useSelector(state => state.suppliers.suppliers);
    const { t } = useTranslation();

    const startDate = format(new Date(), 'yyyy-MM-dd');
    const endDate = format(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd');
    const pad = (n) => n.toString().padStart(2, '0');
    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateMouvementFrom: startDate,
        dateMouvementTo: endDate,
        typeDocument: ''
    });

    const dispatch = useDispatch();
    console.log(soldesFournisseur)

    useEffect(() => {
        dispatch(supplierActions.search({
            query: ""
        }));
        dispatch(soldeActions.searchFournisseur(filters));
    }, []);

    const handleSearch = (e) => {
        e && e.preventDefault();
        dispatch(soldeActions.searchFournisseur(filters));
    };

    const handleExport = () => {
        // Logic to handle export of mouvements
        // This could be a call to a service that generates a report or downloads data
    }

    const founisseurOptions = fournisseurs?.map(fournisseur => ({
        value: fournisseur.id,
        label: fournisseur.typeFournisseur === 'PARTICULIER'
            ? `${fournisseur.nom} ${fournisseur.prenom || ''} `
            : fournisseur.entreprise,
    })) ?? [];


    const founisseurOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...founisseurOptions
    ];

    const totalDebit = soldesFournisseur?.reduce((sum, m) => sum + (Number(m.debit) || 0), 0) || 0;
    const totalCredit = soldesFournisseur?.reduce((sum, m) => sum + (Number(m.credit) || 0), 0) || 0;
    const soldeActuel = soldesFournisseur && soldesFournisseur.length > 0 ? soldesFournisseur[soldesFournisseur.length - 1].soldeApres : 0;

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('nav.supplierReports', 'Opérations fournisseurs')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button
                                    color="success"
                                    onClick={() => handleExport()}
                                    className="me-2"
                                >
                                    <FaFileExport className="me-2" />
                                    {t('export.salesExport', 'Export Etats')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Search Filters */}
            <Row className="mb-3">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody>
                            <Form inline onSubmit={handleSearch} className="row g-3 ">
                                <Col md={3}>
                                    <Label htmlFor="fournisseurId">{t('reception.supplier')}:</Label>
                                    <Select
                                        id="fournisseurId"
                                        options={founisseurOptionsWithAll}
                                        value={founisseurOptionsWithAll.find(option => option.value === filters.fournisseurId)}
                                        onChange={(selectedOption) => setFilters(f => ({ ...f, fournisseurId: selectedOption ? selectedOption.value : null }))}
                                        placeholder={t('reception.selectFournisseur')}
                                        isSearchable
                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="dateMouvementFrom">Date début</Label>
                                        <Input
                                            type="date"
                                            id="dateMouvementFrom"
                                            value={filters.dateMouvementFrom}
                                            onChange={e => setFilters(f => ({ ...f, dateMouvementFrom: e.target.value }))}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="dateMouvementTo">Date fin</Label>
                                        <Input
                                            type="date"
                                            id="dateMouvementTo"
                                            value={filters.dateMouvementTo}
                                            onChange={e => setFilters(f => ({ ...f, dateMouvementTo: e.target.value }))}
                                        />
                                    </FormGroup>
                                </Col>
                                {/* <Col md={3}>
                                    <FormGroup>
                                        <Label for="typeDocument">Type Document</Label>
                                        <Input
                                            type="select"
                                            id="typeDocument"
                                            value={filters.typeDocument}
                                            onChange={e => setFilters(f => ({ ...f, typeDocument: e.target.value }))}
                                        >
                                            <option value="">Tous</option>
                                            <option value="FACTURE">Facture</option>
                                            <option value="BON_LIVRAISON">Bon de livraison</option>
                                            <option value="DEVIS">Devis</option>
                                            <option value="AVOIR">Avoir</option>
                                            <option value="PAIEMENT">Paiement</option>
                                            <option value="AVANCE">Avance</option>
                                            <option value="AJUSTEMENT_MANUEL">Ajustement manuel</option>
                                        </Input>
                                    </FormGroup>
                                </Col> */}
                                <Col md={2} >
                                    <Button color="primary" type="submit" className="mt-4">
                                        <FaSearch className="me-2" />
                                        {t('search', 'Rechercher')}
                                    </Button>
                                </Col>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Table of mouvements */}
            <Row>
                <Col>
                    <Card className="shadow-sm">
                        <CardBody>
                            {loading ? (
                                <div className="text-center my-4"><Spinner color="primary" /></div>
                            ) : error ? (
                                <div className="text-danger">Erreur lors du chargement des mouvements.</div>
                            ) : (
                                <Table bordered hover size="sm" className="mb-0 align-middle">
                                    <thead className="table-primary">
                                        <tr>
                                            <th >Référence</th>
                                            <th >Fournisseur</th>
                                            <th >Opération</th>
                                            <th >Date Opération</th>
                                            <th >Débit</th>
                                            <th >Crédit</th>
                                            <th >Solde Avant</th>
                                            <th >Solde Après</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {soldesFournisseur && soldesFournisseur.length > 1 ? (
                                            soldesFournisseur.map((m, idx) => (
                                                <tr key={idx} className={idx === 0 ? 'fw-bold' : ''}>
                                                    <td>{m.reference}</td>
                                                    <td>{m.fournisseur}</td>
                                                    <td>{m.description}</td>
                                                    <td>{m.dateOperation}</td>
                                                    <td>{formatMoney(m.debit)}</td>
                                                    <td>{formatMoney(m.credit)}</td>
                                                    <td>
                                                        {Number(m.soldeAvant) > 0 ? (
                                                            <b>
                                                                <span className="text-success">+{formatMoney(Math.abs(Number(m.soldeAvant)))}</span>
                                                            </b>
                                                        ) : Number(m.soldeAvant) < 0 ? (
                                                            <b>
                                                                <span className="text-danger">-{formatMoney(Math.abs(Number(m.soldeAvant)))}</span>
                                                            </b>
                                                        ) : (
                                                            <b>
                                                                <span className="text-dark">0.00</span>
                                                            </b>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {Number(m.soldeApres) > 0 ? (
                                                            <b>
                                                                <span className="text-success">+{formatMoney(Math.abs(Number(m.soldeApres)))}</span>
                                                            </b>
                                                        ) : Number(m.soldeApres) < 0 ? (
                                                            <b>
                                                                <span className="text-danger">-{formatMoney(Math.abs(Number(m.soldeApres)))}</span>
                                                            </b>
                                                        ) : (
                                                            <b>
                                                                <span className="text-dark">0.00</span>
                                                            </b>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center py-5">
                                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                                        <span style={{ fontSize: '2rem', color: '#adb5bd' }}>
                                                            <FaTruck />
                                                        </span>
                                                        <div className="mt-2 text-muted">
                                                            {t('mouvements.noData', 'Aucun mouvement trouvé.')}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    {soldesFournisseur && soldesFournisseur.length > 1 ? (<tfoot className="table-light">
                                        <tr className="table-secondary fw-bold">
                                            <td colSpan={4} className="text-end">Totaux :</td>
                                            <td>{totalDebit.toLocaleString()}</td>
                                            <td>{totalCredit.toLocaleString()}</td>
                                            <td colSpan={2} className="text-start">
                                                {`Solde au ${filters.dateMouvementTo} : `}
                                                {Number(soldeActuel) > 0 ? (
                                                    <b><span className="text-success">+{Math.abs(Number(soldeActuel)).toLocaleString()}</span></b>
                                                ) : Number(soldeActuel) < 0 ? (
                                                    <b><span className="text-danger">-{Math.abs(Number(soldeActuel)).toLocaleString()}</span></b>
                                                ) : (
                                                    <b><span className="text-dark">0</span></b>
                                                )}
                                            </td>
                                        </tr>
                                    </tfoot>) : null}
                                </Table>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );

}

export default MouvementSoldeFournisseur;